import React, { Component } from "react";
import { ProjectProperty } from "@eres/ejari-api/Entity/LeasedProperties";
import ListDataView from "@my-dld/components/DataView/ListDataView";
import CardNoData from "@my-dld/components/CardNoData";
import { ProjectPropertyProps, RenderHeader, RenderListItem, } from "@eres/ejari-web/component/Leased/ProjectPropertiesListView";
import { I8N, LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";

class PropertiesListView extends Component<ProjectPropertyProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { properties, onPropertySelect } = this.props;
		return <React.Fragment>
			<ListDataView
				items={ properties }
				renderListHeader={ () => <RenderHeader/> }
				renderListItem={ ( item: ProjectProperty, index: number ) => {
					return <RenderListItem
						key={ "project_buildings_list_" + index }
						property={ item }
						onPropertySelect={ onPropertySelect }/>;
				} }/>
			{ properties.length === 0 && <CardNoData containerClass="alert alert-warning"/> }
		</React.Fragment>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				//language: LocaleUtil.Select( DataTableLang ),
                language: { url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/" + (I8N.current == "ar" ? "Arabic.json" : "English.json"), lengthMenu: '_MENU_' },
                dom: "<'table-responsive'rt>" + "<'dt-cfooter'i<'dt-fpl'pl>>",
                pagingType: "simple_numbers",
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

export default PropertiesListView;
